import React, { useEffect, useState } from "react";
import "./Carousel.scss";
const chunkArray = (arr, size) =>
    arr.reduce((acc, _, i) => {
        if (i % size === 0) acc.push(arr.slice(i, i + size));
        return acc;
    }, []);

const Carousel = ({ images }) => {
    const slides = chunkArray(images, 4);
    const [index, setIndex] = useState(0);
    const [paused, setPaused] = useState(false);
    const nextSlide = () =>
        setIndex((prev) => (prev + 1) % slides.length);
    useEffect(() => {
        if (paused) return;
        const timer = setInterval(() => {
            nextSlide();
        }, 3000);

        return () => clearInterval(timer);
    }, [paused, index]);
    return (
        <div className="regal-carousel"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}>
            <div
                className="regal-carousel-track"
                style={{ transform: `translateX(-${index * 100}%)` }}
            >
                {slides.map((group, i) => (
                    <div className="regal-carousel-slide" key={i}>
                        {group.map((img, j) => (
                            <img src={img?.src} key={j} alt="" className="regal-carousel-img" />
                        ))}
                    </div>
                ))}
            </div>
            <div className="regal-carousel-bottom">
                <div className="regal-carousel-left" />
                <div className="regal-carousel-dots">
                    {slides.map((_, i) => (
                        <div
                            key={i}
                            className={`dot ${i === index ? "active" : ""}`}
                            onClick={() => setIndex(i)}
                        ></div>
                    ))}
                </div>
                <div className="regal-carousel-text ">{4 * (index + 1)}/{images.length}</div>
            </div>

        </div >
    );
}
export default Carousel